export default __webpack_public_path__ + "b421d07479eec89a9b120e0aec7b542c.svg";